// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/trello-logo-gray-spirit.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KdZ4uZ6XYvE93l {
  position: relative;
  height: 30px;
  padding: 5px;
  overflow: hidden;
  background-color: var(--ds-surface, #ffffff);
}
.KdZ4uZ6XYvE93l .rtS3GNu8QpaVUr {
  display: block;
  width: 80px;
  height: 16px;
  margin: 7px 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
}
.KdZ4uZ6XYvE93l .rtS3GNu8QpaVUr:hover {
  opacity: 0.8;
}
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp {
  position: absolute;
  top: 4px;
  right: 0;
  padding: 6px;
  font-weight: var(--ds-font-weight-regular, 400);
}
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp a:link,
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp a:active,
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp a:visited {
  color: var(--ds-link-pressed, #0055cc);
  text-decoration: none;
}
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp a:link,
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp a:hover {
  color: var(--ds-link, #0c66e4);
}
.KdZ4uZ6XYvE93l .kRD9cgn7fHr7Cp .LW03V9wIr7qX5A {
  margin-left: 10px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardFooter": `KdZ4uZ6XYvE93l`,
	"boardFooterLogo": `rtS3GNu8QpaVUr`,
	"boardFooterLinks": `kRD9cgn7fHr7Cp`,
	"footer-logout": `LW03V9wIr7qX5A`
};
export default ___CSS_LOADER_EXPORT___;
